module.exports = __webpack_public_path__ + "static/media/why_es.54a1bcad.vtt";